<template>
    <main class="SectionContact-MAIN">
        <section>
        
            <h1 v-if="step == 1">CONTACTO</h1>
            <h1 v-if="step == 2">FORMULARIO</h1>
            <h1 v-if="step == 3">ENVIADO</h1>
            <hr/>

            <div v-if="step == 1" class="SectionContact-step1">
                <p><b>CORREO:</b> <span>CONTACTO@APART.COM</span></p>
                <p><b>TELÉFONO:</b> <span>+52 55 3325 9878</span></p>
                <p><b>INSTAGRAM:</b> <span>@APART</span></p>
                <hr/>
                <p class="SectionContact-soft" lang="es">
                    ESTE ES EL PUNTO DE ENTRADA. COMPARTE TU CONSULTA. REVISAREMOS EL MENSAJE Y RESPONDEREMOS CON LA INFORMACIÓN PERTINENTE.
                </p>
            </div>

            <div v-if="step == 2" class="SectionContact-step2">
                <p class="SectionContact-deco">
                    {{ date.toISOString() }}<br/>
                    REF: AP-{{ date.getFullYear() }}/{{ selectedArtwork ? `ART-${selectedArtwork}` : date.getDate() }}
                </p>
                <label>
                    <p>NOMBRE:</p>
                    <input type="text" pattern="a-zA-Z0-9_.+\-]{2,}" v-model="form.name"/>
                </label>
                <label>
                    <p>CORREO:</p>
                    <input type="email" pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$" v-model="form.email"/>
                </label>
                <label>
                    <p>MENSAJE:</p>
                    <textarea pattern="a-zA-Z0-9_.+\-]{2,}" v-model="form.msg"></textarea>
                </label>
            </div>

            <div v-if="step == 3" class="SectionContact-step3">
                <h2>
                    <span>FICHA</span>
                    <p class="SectionContact-deco">
                        {{ date.toISOString() }}<br/>
                        REF: AP-{{ date.getFullYear() }}/{{ selectedArtwork ? `ART-${selectedArtwork}` : date.getDate() }}
                    </p>
                </h2>
                <p><b>NOMBRE:</b> <span>{{ form.name }}</span></p>
                <p><b>CORREO:</b> <span>{{ form.email }}</span></p>
                <p><b>MENSAJE:</b> <span>{{ form.msg }}</span></p>
                <hr/>
                <p class="SectionContact-soft" lang="es">
                    TIEMPO ESTIMADO DE RESPUESTA: 24-48 H HÁBILES.
                </p>
            </div>

            <div class="SectionContact-msg">{{ alertMsg }}</div>

            <button @click="nextStep()">
                <span v-if="step == 1">MENSAJE</span>
                <span v-if="step == 2">ENVIAR</span>
                <span v-if="step == 3">INICIO</span>
            </button>

        </section>
    </main>
</template>

<script>
export default {
    name: 'SectionContact',
    props: {
        id: { type: [String, Number, null], required: false }
    },
    data(){
        return{
            step: 1,
            date: new Date(),
            form: {
                subject: '',
                name: '',
                email: '',
                msg: ''
            },
            artworkData: {},
            alertMsg: ''
        }
    },
    methods: {
        async sendContactData(payload){
            const response = await fetch(`${this.$ENDPOINT}/api/contact_create.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            })

            return await response.json();
        },

        async nextStep(){
            this.alertMsg = '';
            if(this.step == 1)
                return this.step = 2;
            if(this.step == 2){
                const F = this.form;
                if(!/[a-zA-Z0-9_.+-]{2,}/.test(F.name))
                    return this.alertMsg = "Nombre requerido.";
                if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(F.email))
                    return this.alertMsg = "Correo elecrónico inválido.";
                if(!/[a-zA-Z0-9_.+-]{2,}/.test(F.msg))
                    return this.alertMsg = "Mensaje requerido.";   

                // aqui se hace el guardado de mensaje en bd, y si es correcto:
                const payload = {
                    subject: F.subject,
                    username: F.name,
                    email: F.email,
                    message: F.msg,
                    requested_artwork_id: this.id ?? null
                };

                const result = await this.sendContactData(payload);
                if(result.status == "success"){
                    this.step = 3;
                }else{
                    this.alertMsg = "Hubo un error al enviar el mensaje. Reintentelo más tarde.";
                }
                return;
            }
            if(this.step == 3){
                const from = this.$route.query.from;
                if (from === 'artwork' && this.$route.params?.id) {
                    this.$router.push({ name: 'artworkcard', params: { id: String(this.$route.params.id) } })
                    return;
                }
                this.$router.push({ name: 'parenthesis' })
            }
        },

        async setSubject(){
            if(this.selectedArtwork){
                const response = await fetch(`${this.$ENDPOINT}/api/get_artwork.php?id=${encodeURIComponent(this.id)}`);
                const result = await response.json();
                if(result.status == "success") this.artworkData = result.artwork;
            }
            this.form.subject = this.selectedArtwork ? `ARTWORK#${this.selectedArtwork}: ${this.artworkData.titulo}` : 'Sin asunto.';
        },
    },
    mounted(){
        this.setSubject();
    },
    watch: {
        id(){
            this.setSubject();
        }
    }
}
</script>

<style scoped lang="stylus">
.SectionContact-MAIN
    height: 100dvh
    overflow-y: auto
    background-color: black
    display: flex
    align-items: center
    justify-content: center

    >section
        padding: 2.5vw
        width: calc(100% - 10vw)
        height: calc(100% - 10vw)
        background-color: white
        border-radius: 5vw

        h1
            margin-top: 10px
            margin-bottom: -10px
            font-family: "Archivo ExtraCondensed", sans-serif
            font-size: 11vw

        hr
            border: 1px solid black
            margin: 15px 0

        .SectionContact-soft
            color: #707070
            text-transform: uppercase
            overflow-wrap: break-word
            word-break: normal  
            -webkit-hyphens: auto
            -moz-hyphens: auto
            -ms-hyphens: auto
            hyphens: auto
            line-height: 1.8ch

        .SectionContact-deco
            color: #707070
            text-align: right !important
            font-size: 3vw
            font-weight: 100

/* step 1 */
.SectionContact-step1
.SectionContact-step3
    font-family: "DM Mono", monospace

    p:not(.SectionContact-soft):not(.SectionContact-deco)
        margin: 0
        display: grid
        grid-template-columns: 35% auto

/* step 2 */
.SectionContact-step2
    font-family: "DM Mono", monospace

    >label:not(:last-child)
        display: flex
        align-items: center
        border-bottom: 2px solid black
        padding-top: 15px

        >p
            margin: 0

        >input
            width: 100%
            padding: 5px 0
            padding-left: 1ch
            height: 100%
            margin: 0
            border: none

    >label:last-child

        >p
            margin-bottom: 0

        textarea
            width: calc(100% - 2vw)
            height: 25vh
            resize: none
            border: none

/* step 3 */
.SectionContact-step3
    position: relative
    
    h2
        display: flex
        align-items: center
        justify-content: space-between
        margin-top: -10px
        margin-bottom: 5px

.SectionContact-msg
    font-family: "DM Mono", monospace
    border-bottom: 2px solid black
    color: red
    text-transform: uppercase
    font-size: 3vw
    text-align: center
    position: fixed
    margin: auto
    left: 0
    right: 0
    bottom: calc(15vw + 47px)
    width: calc(100vw - 10vw)

button
    height: 47px
    width: calc(180px + 18px + 18px)
    background-color: rgb(1, 90, 255)
    border: none
    color: white
    max-width: 75vw
    position: fixed
    margin: auto
    left: 0
    right: 0
    bottom: 6vw
    border-radius: 100vw
    z-index: 1
    font-family: "DM Mono", monospace
    cursor: pointer

    >span
        font-size: 15px
</style>